export const TAB_ORDER = ['/dashboard', '/workout', '/chat', '/achievements', '/settings'];

// Maps any route to its owning bottom tab. Program day pages (/workout/<id>)
// belong to the Program tab; the active workout runner owns no tab.
export function resolveTabPath(pathname) {
  if (pathname === '/') return '/dashboard';
  if (pathname.startsWith('/workout/active')) return null;
  if (pathname === '/workout' || pathname.startsWith('/workout/')) return '/workout';
  return TAB_ORDER.includes(pathname) ? pathname : null;
}
